<template>
  <div class="app-container">
    <!-- 搜索栏 -->
    <el-card shadow="never" class="search-card">
      <el-form :inline="true" :model="searchQuery">
        <el-form-item label="商品名称">
          <el-input v-model="searchQuery.spuName" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="商品编码">
          <el-input v-model="searchQuery.spuCode" placeholder="请输入编码" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" :icon="Search">查询</el-button>
          <el-button @click="resetSearch" :icon="Refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 操作栏 -->
    <div class="action-bar">
      <el-button type="primary" :icon="Plus" @click="goToAdd">添加商品</el-button>
    </div>

    <!-- 数据表格 -->
    <el-table :data="tableData" border style="width: 100%" v-loading="loading">
      <el-table-column type="selection" width="55" />
      <el-table-column prop="spuCode" label="商品编号" width="120" />
      <el-table-column prop="spuName" label="商品名称" min-width="250" show-overflow-tooltip />
      <el-table-column prop="catName" label="类目" width="120" />
      <el-table-column prop="price" label="价格" width="100">
        <template #default="{ row }">¥{{ (row.minSellingPrice===row.maxSellingPrice)?row.maxSellingPrice:`${row.minSellingPrice}~${row.maxSellingPrice}` }}</template>
      </el-table-column>
      <el-table-column prop="stockNum" label="库存" width="100" />
      <el-table-column label="上下架" width="100">
        <template #default="{ row }">
          <el-switch
            :model-value="row.goodsStatus === 'grounding'"
            @change="val => handleStatusChange(row, val)"
          />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template #default="{ row }">
          <el-button link type="primary" @click="handleEdit(row)">编辑</el-button>
          <el-button link type="primary" @click="handleCopy(row)">复制链接</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        v-model:current-page="queryParams.pageIndex"
        v-model:page-size="queryParams.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="getList"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { Search, Refresh, Plus } from '@element-plus/icons-vue';
// 假设这是你封装的请求工具
// import app from '@/utils/request';

import {onActivated, useCurrentAppInstance} from '@zto/zpage'
import {setClipboardText} from "@/utils";
import {ElMessage} from "element-plus";
const app = useCurrentAppInstance()
const loading = ref(false);
const tableData = ref([]);
const total = ref(0);

const searchQuery = reactive({
  spuName: '',
  spuCode: ''
});

const queryParams = reactive({
  pageIndex: 1,
  pageSize: 10
});

// 获取列表数据
const getList = async () => {
  loading.value = true;
  try {
    const res = await app.request({
      api: 'pc/goods/querySpuInfoList',
      params: {  }
    });
    tableData.value = res;
    total.value = 10000;
  } finally {
    loading.value = false;
  }
};

const handleSearch = () => {
  queryParams.pageIndex = 1;
  getList();
};

const resetSearch = () => {
  searchQuery.spuName = '';
  searchQuery.spuCode = '';
  handleSearch();
};

const handleStatusChange = async (row, val) => {
  let apiUrl
  if (row.goodsStatus === 'grounding'){
    apiUrl = 'pc/goods/offShelfSpuInfo'
  }
  else {
    apiUrl = 'pc/goods/groundingSpuInfo'
  }
  // 模拟更新状态的请求
  await app.request({
    api: apiUrl,
    method: 'post',
    data: {
      spuCode: row.spuCode,
      goodsStatus: val ? 'grounding' : 'offline'
    }
  });
  // // 更新列表数据
  getList();
};

const handleCopy=(row)=>{
  //pages/entry/detail/index?spuCode=23b9ed00-9af5-4ff4-b704-5a28d0c2fd98
  setClipboardText(`pages/entry/detail/index?spuCode=${row.spuCode}`)
  ElMessage.success('复制成功');
}

const handleEdit=(row)=>{
  app.router.goto({
    title: '编辑商品',
    name: '',
    path: '/goodsedit',
    query: {
      operateType: 'edit',
      id: row.spuCode
    }
  })
}

const goToAdd = () => {
  // 路由跳转到新增页
  app.router.goto({
    title: '新增商品',
    name: '',
    path: '/goodsedit',
    query: {
      operateType: 'add'
    }
  })
};

onMounted(() => {
  getList();
});

onActivated(() => {
  getList()
})
</script>

<style scoped>
.app-container { padding: 20px; background: #f5f7fa; min-height: 100vh; }
.search-card { margin-bottom: 20px; }
.action-bar { margin-bottom: 16px; }
.pagination-container { margin-top: 20px; display: flex; justify-content: flex-end; }
</style>
